const ResourcesRenderer = require("../common/ResourcesRenderer");
const Utils = require("../common/Utils");

/**
 * @extends {ResourcesRenderer}
 * @constructor
 */
function AppRenderer() {
    ResourcesRenderer.call(this);
    const self = this;

    /**
     * @override
     *
     * @param {ResourcesModel~ResourceItem} resource
     *
     * @returns {jQuery}
     */
    this.render = function(resource) {
        console.debug("Attempt to render resource: Name:" + resource.name + " id:+" + resource.id);

        let $div;
        if (self.hasCustomIcon(resource)) {
            $div = self.renderCustomIcon(resource);
        } else {
            $div = self.renderStandardIcon(resource);
        }

        if (resource.dyn_state === "Disabled") {
            $div.append($("<div>", {class : "ui-li-thumb connectionOverlay"})
                .append(self.renderStateBadge(resource, [])));
        }
        return $div;
    };
}

Utils.inherits(AppRenderer, ResourcesRenderer);

module.exports = AppRenderer;